import appConfig from '../appConfig';

export function getPPFInformation() {
  return {
    flow_id: appConfig.getFlowId(),
    flow_version: appConfig.getFlowVersion(),
    uuid: appConfig.getMyConfig().uuid
  };
}

export function aggregatePayload(...args) {
  return () => {
    const payload = {};

    args.forEach((payloadFunction) => {
      Object.assign(payload, payloadFunction());
    });

    return payload;
  };
}
